import * as actionTypes from "./actionTypes";

// cookie-auth pilot — opt-in. Set via devtools console:
// localStorage.setItem("enable_cookie_auth", "true"), then refresh.
// Read once at boot (see src/containers/App.js componentDidMount) into Redux —
// hooks read the Redux value (src/redux/selectors/cookieAuthPilotSelectors.ts),
// not localStorage directly, so participation is fixed for the session until
// the next page refresh.
export const COOKIE_AUTH_PILOT_FLAG = "enable_cookie_auth";

export const loadCookieAuthPilotFlag = () => ({
  isOptedIn: localStorage.getItem(COOKIE_AUTH_PILOT_FLAG) === "true",
  type: actionTypes.COOKIE_AUTH_PILOT_OPT_IN_LOADED,
});
